module.exports = __webpack_public_path__ + "img/marker set.48cd3b26.svg";